import React from 'react';
import { Helmet } from 'react-helmet';

class GoogleAnalytics extends React.Component {
  componentDidMount() {
    const { trackingId } = this.props;
    if (typeof window !== 'undefined' && this.checkConsentCookie()) {
      window.ga = window.ga || function() {(ga.q = ga.q || []).push(arguments)};
      ga.l = +new Date;
      ga('create', trackingId, 'auto');
      ga('send', 'pageview');
    }
  }

  checkConsentCookie() {
	if (typeof window !== 'undefined') {
    const cookies = document.cookie.split(';').map(cookie => cookie.trim());
    for (let cookie of cookies) {
      const [key, value] = cookie.split('=');
      if (key === 'cookies_consent' && value === 'true') {
        return true;
      }
    }
	}
    return false;
  }

  render() {
    const { trackingId } = this.props;
    const hasConsent = this.checkConsentCookie();
    return hasConsent ? (
      <Helmet>
        <script async src={`https://www.googletagmanager.com/gtag/js?id=${trackingId}`}></script>
        <script>
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${trackingId}');
          `}
        </script>
      </Helmet>
    ) : null ;
  }
}

export default GoogleAnalytics;
